import { useCurrentUser } from '@hooks';

export function useAvatar() {
  let { data, isLoading, error } = useCurrentUser();

  let user = {
    firstName: data?.firstName,
    secondName: data?.lastName,
  };

  return {
    fullName: `${user?.firstName} ${user?.secondName}`,
    isLoading,
  };
}
